import axios from 'axios';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import Cookies from 'js-cookie';
import {createApp, defineAsyncComponent} from 'vue';
import 'justifiedGallery';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/aspectratio/ls.aspectratio';
import {tns} from "tiny-slider/src/tiny-slider"
import {createPinia} from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import storeReset from './stores/plugins/storeReset'
import 'focus-visible'

UIkit.use(Icons);

window.$ = window.jQuery = require('jquery');
window.axios = axios;
window.UIkit = UIkit;
window.Cookies = Cookies;
window.tns = tns;

window.COOKIE_NAME_LEAD = 'CWLEAD';

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
pinia.use(storeReset)

const app = createApp()

// Banner components
app.component('banner', defineAsyncComponent(() => import('./components/banners/Banner.vue')));
app.component('cookie-notice', defineAsyncComponent(() => import('./components/banners/CookieNotice.vue')));

// Chooser components
app.component('the-chooser', defineAsyncComponent(() => import('./components/chooser/TheChooser.vue')));
app.component('chooser-preload-product-line-sausage', defineAsyncComponent(() => import('./components/chooser/ChooserPreloadProductLineSausage.vue')));

// Design tool components
app.component('design-tool-goto-button', defineAsyncComponent(() => import('./components/design-tool/DesignToolGotoButton.vue')));
app.component('design-tool-goto-button-sausage', defineAsyncComponent(() => import('./components/design-tool/DesignToolGotoButtonSausage.vue')));
app.component('design-tool-goto-link', defineAsyncComponent(() => import('./components/design-tool/DesignToolGotoLink.vue')));

// Modals components
app.component('three-dee-modal', defineAsyncComponent(() => import('./components/ui/ThreeDeeModal.vue')));
app.component('lead-modal', defineAsyncComponent(() => import('./components/lead/LeadModal.vue')));
app.component('catalog-modal', defineAsyncComponent(() => import('./components/catalog/CatalogModal.vue')));
app.component('birds-eye-modal', defineAsyncComponent(() => import('./components/ui/BirdsEyeModal.vue')));
app.component('show-lead-modal-main-nav', defineAsyncComponent(() => import('./components/lead/ShowLeadModalMainNav.vue')));
app.component('show-lead-modal-button', defineAsyncComponent(() => import('./components/lead/ShowLeadModalButton.vue')));
app.component('show-lead-modal-product-grid', defineAsyncComponent(() => import('./components/lead/ShowLeadModalProductGrid.vue')));
app.component('design-tool-width-modal', defineAsyncComponent(() => import('./components/design-tool/DesignToolWidthModal.vue')));

// Wishlist components
app.component('wishlist', defineAsyncComponent(() => import('./components/wishlist/Wishlist.vue')));
app.component('wishlist-item', defineAsyncComponent(() => import('./components/wishlist/WishlistItem.vue')));
app.component('wishlist-link-main-nav', defineAsyncComponent(() => import('./components/wishlist/WishlistLinkMainNav.vue')));
app.component('save-to-wishlist-mini-heart-style', defineAsyncComponent(() => import('./components/wishlist/SaveToWishlistMiniHeartStyle.vue')));
app.component('save-to-wishlist-portrait-style', defineAsyncComponent(() => import('./components/wishlist/SaveToWishlistPortraitStyle.vue')));
app.component('remove-from-wishlist', defineAsyncComponent(() => import('./components/wishlist/RemoveFromWishlist.vue')));

// Misc components
app.component('product-dimensions', defineAsyncComponent(() => import('./components/utilities/ProductDimensions.vue')));
app.component('view-birds-eye', defineAsyncComponent(() => import('./components/ui/ViewBirdsEye.vue')));
app.component('view-three-dee-portrait-style', defineAsyncComponent(() => import('./components/ui/ViewThreeDeePortraitStyle.vue')));
app.component('the-product-search', defineAsyncComponent(() => import('./components/site/TheProductSearch.vue')));


app.use(pinia)
app.mount('#vue-app');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = $('meta[name="csrf-token"]').attr('content');
